import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../../theme';
import { styleConstants } from '../../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        user: {
            border: `1px solid ${brandColors.borderGray}`,
            marginBottom: theme.spacing(1.5),
            padding: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
            display: 'flex',
        },
        activityName: {
            fontWeight: 900,
            marginRight: theme.spacing(0.5),
        },
        activityTable: {
            marginTop: 0,
        },
        removeuser: {
            marginLeft: theme.spacing(1),
            '& svg': {
                color: theme.palette.error.dark,
            },
        },
        buttonContainer: {
            display: 'flex',
            marginTop: theme.spacing(2),
        },
        container: {
            marginTop: theme.spacing(2),
        },
        deleteUserDialogContainer: {
            paddingBottom: theme.spacing(2),
        },
        deleteBtn: {
            marginLeft: theme.spacing(1),
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            flexGrow: 1,
            '&:hover': {
                backgroundColor: theme.palette.error.dark,
            },
        },
        infoContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flexGrow: 1,
        },
        button: {
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
        title: {
            color: theme.palette.primary.dark,
            paddingBottom: '0.25rem',
            [theme.breakpoints.down('xs')]: {
                fontSize: '1.5rem',
            },
        },
        tableWrapper: {
            backgroundColor: theme.palette.background.paper,
            overflow: 'auto',
            maxWidth: '100%',
        },
    };
};
